import { inject, Injectable } from '@angular/core';

import { NSCConsentChoice, NSCConsentData, NSCConsentSelection } from '../../model/nsc-consent';
import { PreregistrationData } from '../../model/preregistration-data';
import { GcdmClient } from './gcdm.client';
import { GcdmViewModelMapper } from './mapper/view-model.mapper';
import { PreregistrationResponse } from './model/response.model';

@Injectable({
  providedIn: 'root',
})
export class GcdmService {
  private readonly gcdmClient = inject(GcdmClient);
  private readonly mapper = inject(GcdmViewModelMapper);

  private static readonly policyDocumentName = 'Marketing';

  async getNscConsents(brand?: string): Promise<NSCConsentData> {
    const response = await this.gcdmClient.getPolicyDocument({
      policyDocumentName: GcdmService.policyDocumentName,
      brand,
    });
    return this.mapper.policyDocumentToConsent(response);
  }

  async getNscConsentSelection(gcid: string): Promise<NSCConsentSelection> {
    const consentsResponse = await this.gcdmClient.getNscConsentChoices({ gcid });
    return this.mapper.unwrapConsentChoices(consentsResponse, GcdmService.policyDocumentName);
  }

  async setNscConsentChoices(gcid: string, consentChoices: NSCConsentChoice[]) {
    const mappedConsentChoices = this.mapper.mapNscConsentChoices(consentChoices);
    return await this.gcdmClient.setConsentChoices(gcid, mappedConsentChoices);
  }

  async preregister(data: PreregistrationData): Promise<PreregistrationResponse> {
    const request = this.mapper.mapPreregistrationData(data);
    return await this.gcdmClient.preregister(request);
  }
}
